import { createAsyncTypes } from 'utils/ActionCreator'

export const QUICK_INTEGRATION_SAVE_ASYNC = createAsyncTypes(
  'QUICK_INTEGRATION_SAVE_ASYNC',
  'Settings/EmailServer/QuickIntegration'
)

export const QUICK_INTEGRATION_CONTINUE =
  'Settings/EmailServer/QuickIntegration/QUICK_INTEGRATION_CONTINUE'
